/* Independently authored Shopify interactions. No external theme runtime. */
(() => {
  'use strict';
  const raw = document.getElementById('StoreConfig');
  const config = raw ? JSON.parse(raw.textContent) : {};
  const root = (config.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const money = amount => new Intl.NumberFormat(config.locale || 'nl-NL', { style: 'currency', currency: config.currency || 'EUR' }).format((amount || 0) / 100) + (config.currencyCode ? ` ${config.currency || 'EUR'}` : '');
  // Teksten uit de locale-bestanden (layout/theme.liquid → StoreConfig); [naam] wordt ingevuld
  const t = (key, values = {}) => (config.strings?.[key] || key).replace(/\[(\w+)\]/g, (match, name) => values[name] ?? match);
  const status = text => { const el = document.getElementById('StoreStatus'); if (el) el.textContent = text; };
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const openDialog = (id, opener) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    if (document.querySelector('dialog[open]')) return;
    dialog._opener = opener || document.activeElement;
    dialog.showModal();
    if (id === 'SearchDialog') dialog.querySelector('input')?.focus();
  };
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-open-dialog]');
    if (open) openDialog(open.dataset.openDialog, open);
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement && event.target.open) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const cartLink = event.target.closest('[data-cart-open]');
    if (cartLink && config.cartType === 'drawer' && document.getElementById('CartDrawer')) { event.preventDefault(); openDialog('CartDrawer', cartLink); }
    const quantityStep = event.target.closest('[data-quantity-step]');
    if (quantityStep) {
      const input = quantityStep.closest('.quantity')?.querySelector('input');
      if (!input || input.disabled) return;
      const step = Number(input.step) || 1, min = Number(input.min) || 0, max = input.max ? Number(input.max) : Infinity;
      input.value = Math.max(min, Math.min(max, Number(input.value) + Number(quantityStep.dataset.quantityStep) * step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (event.target.closest('[data-scroll-top]')) window.scrollTo({ top: 0, behavior: motion() });
  });
  document.addEventListener('close', event => { if (event.target instanceof HTMLDialogElement) event.target._opener?.focus(); }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const dialog = document.querySelector('#SearchDialog[open],#MobileMenu[open],#CartDrawer[open],#PromoDialog[open]');
      if (dialog) { event.preventDefault(); dialog.close(); return; }
      document.querySelectorAll('.nav-dropdown[open]').forEach(el => { el.open = false; el.querySelector('summary')?.focus(); });
    }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-dropdown[open]').forEach(el => { if (!el.contains(event.target)) el.open = false; });
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.nav-dropdown') && event.target.open) document.querySelectorAll('.nav-dropdown[open]').forEach(el => { if (el !== event.target) el.open = false; });
  }, true);

  document.querySelectorAll('.desktop-nav .nav-dropdown').forEach(dropdown => {
    let closeTimer;
    dropdown.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      dropdown.open = true;
    });
    dropdown.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      closeTimer = setTimeout(() => {
        const focused = document.activeElement;
        if (dropdown.contains(focused) && focused.matches(':focus-visible')) return;
        dropdown.open = false;
      }, 180);
    });
  });

  document.querySelectorAll('[data-visual-menu]').forEach(menu => {
    const selectCategory = category => {
      const id = category.dataset.menuCategory;
      menu.querySelectorAll('[data-menu-category]').forEach(item => {
        const active = item === category;
        item.classList.toggle('is-active', active);
        item.querySelector('[data-menu-select]').setAttribute('aria-expanded', String(active));
      });
      menu.querySelectorAll('[data-menu-panel]').forEach(panel => { panel.hidden = panel.dataset.menuPanel !== id; });
    };
    menu.querySelectorAll('[data-menu-category]').forEach(category => {
      category.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') selectCategory(category); });
      category.addEventListener('focusin', () => selectCategory(category));
      category.querySelector('[data-menu-select]').addEventListener('click', () => selectCategory(category));
      category.querySelector('[data-menu-select]').addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          selectCategory(category);
          menu.querySelector('[data-menu-panel]:not([hidden]) a')?.focus();
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const sibling = event.key === 'ArrowDown' ? category.nextElementSibling : category.previousElementSibling;
          sibling?.querySelector('[data-menu-select]').focus();
        }
      });
    });
  });

  const sectionIds = () => [...new Set(['cart-drawer', ...['[data-cart-page]', '[data-cart-page-footer]'].map(selector => document.querySelector(selector)?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '')).filter(Boolean)])];
  let cartQueue = Promise.resolve();
  function queueCart(task) { const operation = cartQueue.then(task); cartQueue = operation.catch(() => {}); return operation; }
  async function fetchJSON(path, options = {}) {
    const response = await fetch(root + path, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    let data;
    try { data = await response.json(); } catch { throw new Error(t('store_unreachable')); }
    if (!response.ok) { const error = new Error(data.description || data.message || t('cart_failed')); error.status = response.status; throw error; }
    return data;
  }
  function applySections(sections) {
    const parser = new DOMParser();
    const focused = document.activeElement;
    const focusItem = focused?.closest('[data-cart-item]');
    const focusKey = focusItem?.querySelector('[data-line-key]')?.dataset.lineKey;
    const focusStep = focused?.dataset.quantityStep;
    const focusWasInput = focused?.matches('[data-cart-quantity]');
    const focusDialog = focused?.closest('dialog')?.id;
    const shouldRestore = !!focused?.closest('[data-cart-drawer-content],[data-cart-page-content],[data-cart-page-footer]');
    for (const html of Object.values(sections || {})) {
      if (!html) continue;
      const doc = parser.parseFromString(html, 'text/html');
      for (const selector of ['[data-cart-drawer-content]', '[data-cart-page-content]', '[data-cart-page-footer]']) {
        const fresh = doc.querySelector(selector), current = document.querySelector(selector);
        if (fresh && current) current.replaceWith(fresh);
      }
      const heading = doc.querySelector('[data-cart-heading]');
      if (heading && document.querySelector('[data-cart-heading]')) document.querySelector('[data-cart-heading]').textContent = heading.textContent;
    }
    if (shouldRestore) {
      const scope = focusDialog ? document.getElementById(focusDialog) : document.querySelector('[data-cart-page]');
      const input = focusKey && scope?.querySelector(`[data-line-key="${CSS.escape(focusKey)}"]`);
      const item = input?.closest('[data-cart-item]');
      const target = focusWasInput ? input : focusStep ? item?.querySelector(`[data-quantity-step="${focusStep}"]`) : item?.querySelector('[data-cart-remove]');
      (target || scope?.querySelector('[data-close-dialog],a,button,input'))?.focus();
    }
  }
  async function refreshCart(data) {
    const ids = sectionIds();
    if (!data.sections || Object.values(data.sections).some(value => !value)) {
      const response = await fetch(`${root}?sections=${encodeURIComponent(ids.join(','))}`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(t('cart_saved'));
      data.sections = await response.json();
    }
    applySections(data.sections);
    const cart = typeof data.item_count === 'number' ? data : await fetchJSON('cart.js');
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  }
  const cartError = message => { document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = message; }); };
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending === 'true' || form.closest('[data-product]')?.dataset.stockBlocked === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('[data-add-button]'), product = form.closest('[data-product]');
    const errorEl = form.querySelector('[data-product-error]');
    const previousLabel = button?.textContent;
    form.dataset.pending = 'true'; if (button) { button.disabled = true; button.textContent = t('adding'); }
    if (errorEl) errorEl.textContent = '';
    // Use the items array: Shopify validates bundle components on this add route.
    // Keep multipart values so line properties, uploads and selling plans survive.
    const formData = new FormData();
    for (const [name, value] of new FormData(form)) {
      const itemField = name.match(/^(id|quantity|selling_plan|properties)(\[.*\])?$/);
      formData.append(itemField ? `items[0][${itemField[1]}]${itemField[2] || ''}` : name, value);
    }
    formData.set('sections', sectionIds().join(',')); formData.set('sections_url', location.pathname);
    queueCart(async () => {
      let data;
      try { data = await fetchJSON('cart/add.js', { method: 'POST', body: formData }); }
      catch (error) {
        // A 422 may still add the available quantity. Reconcile before the next queued action.
        if (error.status === 422) {
          try { await refreshCart({}); cartError(error.message); } catch { /* Keep the original stock error. */ }
        }
        throw error;
      }
      document.dispatchEvent(new CustomEvent('ivonne:cart-added', {detail:{product_id:data.product_id || data.items?.[0]?.product_id}}));
      status(t('added'));
      if (config.cartType === 'page') { location.assign(root + 'cart'); return; }
      try { await refreshCart(data); cartError(''); openDialog('CartDrawer', button); }
      catch { location.assign(root + 'cart'); }
    }).catch(error => { if (errorEl) errorEl.textContent = error.message; status(error.message); })
      .finally(() => { delete form.dataset.pending; if (button) { button.textContent = previousLabel; button.disabled = product?.dataset.available === 'false' || product?.dataset.stockBlocked === 'true'; } product?.dispatchEvent(new Event('product:purchase-state')); });
  });
  async function changeLine(key, quantity, input) {
    const oldValue = input?.defaultValue;
    if (input) input.disabled = true;
    return queueCart(async () => {
      const data = await fetchJSON('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: sectionIds(), sections_url: location.pathname }) });
      try { const cart = await refreshCart(data); cartError(''); status(t('cart_updated', { count: cart.item_count })); }
      catch { location.assign(root + 'cart'); }
    }).catch(error => { cartError(error.message); if (input && oldValue !== undefined) input.value = oldValue; status(error.message); })
      .finally(() => { if (input) input.disabled = false; });
  }
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input || input.disabled) return;
    if (!input.reportValidity() || !Number.isInteger(Number(input.value))) { input.value = input.defaultValue; return; }
    changeLine(input.dataset.lineKey, Number(input.value), input);
  });
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    const input = remove.closest('[data-cart-item]').querySelector('[data-cart-quantity]');
    if (!input.disabled) changeLine(remove.dataset.cartRemove, 0, input);
  });

  function initProduct(product) {
    if (product.dataset.initialized) return;
    product.dataset.initialized = 'true';
    const data = JSON.parse(product.querySelector('[data-product-data]').textContent), form = document.getElementById(product.dataset.formId);
    const options = () => [...product.querySelectorAll('[data-option-index]')].map(field => field.querySelector('select')?.value || field.querySelector('input:checked')?.value);
    const mediaElements = [...product.querySelectorAll('[data-media-id]')];
    let mediaIndex = 0;
    function showMedia(id) {
      const index = mediaElements.findIndex(el => String(el.dataset.mediaId) === String(id));
      if (index < 0) return;
      mediaIndex = index;
      mediaElements.forEach((el, i) => { el.hidden = i !== index; if (i !== index) el.querySelectorAll('video').forEach(video => video.pause()); });
      product.querySelectorAll('[data-media-select]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaSelect === String(id))));
    }
    const setVariant = (variant, updateURL = true) => {
      const available = !!variant?.available;
      product.dataset.available = String(available);
      product.querySelectorAll('[data-variant-id]').forEach(el => { el.value = variant?.id || ''; el.disabled = !variant; });
      product.querySelectorAll('[data-add-button],[data-sticky-submit]').forEach(el => { el.disabled = !available; if (el.matches('[data-add-button]')) el.textContent = (available ? t('add_to_cart') : variant ? t('sold_out') : t('unavailable')).toLocaleUpperCase(config.locale); });
      product.querySelectorAll('[data-product-prices]').forEach(el => {
        const price = el.querySelector('[data-price]'), compare = el.querySelector('[data-compare-price]');
        if (price) price.textContent = variant ? money(variant.price) : t('unavailable');
        if (compare) { compare.textContent = money(variant?.compare_at_price); compare.hidden = !(variant?.compare_at_price > variant?.price); }
      });
      const quantity = product.querySelector('input[name="quantity"]');
      if (quantity && variant) {
        quantity.min = variant.quantityRule.min; quantity.step = variant.quantityRule.increment;
        if (variant.quantityRule.max) quantity.max = variant.quantityRule.max; else quantity.removeAttribute('max');
        if (!quantity.checkValidity()) quantity.value = variant.quantityRule.min;
      }
      product.querySelectorAll('[data-sticky-variant]').forEach(el => { el.value = variant?.id || ''; });
      if (variant?.mediaId) showMedia(variant.mediaId);
      if (variant && updateURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      product.querySelectorAll('[data-option-index]').forEach(field => { const label = field.querySelector('[data-option-label]'); if (label) label.textContent = options()[Number(field.dataset.optionIndex)] || ''; });
      const error = product.querySelector('[data-product-error]'); if (error) error.textContent = '';
      product.dispatchEvent(new Event('product:variant-changed'));
    };
    product.addEventListener('change', event => {
      if (event.target.matches('[data-option]')) setVariant(data.variants.find(v => v.options.every((value, index) => value === options()[index])));
      if (event.target.matches('[data-sticky-variant]')) {
        const variant = data.variants.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        product.querySelectorAll('[data-option-index]').forEach(field => {
          const value = variant.options[Number(field.dataset.optionIndex)];
          field.querySelectorAll('input').forEach(el => { el.checked = el.value === value; });
          const select = field.querySelector('select'); if (select) select.value = value;
        }); setVariant(variant);
      }
    });
    product.addEventListener('click', event => {
      const media = event.target.closest('[data-media-select]'); if (media) showMedia(media.dataset.mediaSelect);
      if (event.target.closest('[data-gallery-prev]') && mediaElements.length) showMedia(mediaElements[(mediaIndex - 1 + mediaElements.length) % mediaElements.length].dataset.mediaId);
      if (event.target.closest('[data-gallery-next]') && mediaElements.length) showMedia(mediaElements[(mediaIndex + 1) % mediaElements.length].dataset.mediaId);
      const sticky = event.target.closest('[data-sticky-submit]');
      if (sticky) {
        if (sticky.closest('[data-sticky-atc]').dataset.action === 'scroll_to_atc') form?.scrollIntoView({ behavior: motion(), block: 'center' });
        else form?.requestSubmit();
      }
    });
    const sticky = product.querySelector('[data-sticky-atc]'), buy = form?.querySelector('[data-add-button]');
    if (sticky && buy) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = sticky.dataset.display !== 'always' && (entry.isIntersecting || entry.boundingClientRect.top > 0); }, { threshold: 0 });
      observer.observe(buy); product._observer = observer;
    }
    const initial = data.variants.find(v => String(v.id) === form?.querySelector('[data-variant-id]')?.value) || data.variants[0];
    setVariant(initial, false);
  }
  function initSlider(slider) {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = 'true';
    const track = slider.querySelector('[data-slider-track]'), controls = slider.querySelector('[data-slider-controls]');
    if (!track || !controls) return;
    const slides = [...track.querySelectorAll(':scope > [data-slide]')], dots = controls.querySelector('[data-slide-dots]');
    if (slides.length < 2) { controls.hidden = true; return; }
    let index = 0, paused = false, timer;
    const go = i => { index = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: motion() }); };
    const update = () => {
      index = slides.reduce((best, el, i) => Math.abs(el.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? i : best, 0);
      dots.querySelectorAll('button').forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      const canScroll = track.scrollWidth > track.clientWidth + 2;
      controls.hidden = !canScroll;
      controls.querySelector('[data-slide-prev]').disabled = track.scrollLeft <= 1;
      controls.querySelector('[data-slide-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    slides.forEach((_, i) => { const dot = document.createElement('button'); dot.type = 'button'; dot.setAttribute('aria-label', t('go_to_item', { index: i + 1 })); dot.addEventListener('click', () => go(i)); dots.append(dot); });
    controls.querySelector('[data-slide-prev]').addEventListener('click', () => go(index - 1));
    controls.querySelector('[data-slide-next]').addEventListener('click', () => go(index + 1));
    const startTimer = () => {
      clearInterval(timer);
      if (slider.dataset.autoplay !== 'true' || paused || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(() => { if (!slider.isConnected) { clearInterval(timer); return; } if (!document.hidden && (slider.dataset.pauseHover === 'false' || !slider.matches(':hover')) && !slider.contains(document.activeElement)) go(track.scrollLeft + track.clientWidth >= track.scrollWidth - 2 ? 0 : index + 1); }, Math.max(2000, Number(slider.dataset.interval) || 5000));
    };
    controls.querySelector('[data-slide-pause]')?.addEventListener('click', event => { paused = !paused; event.currentTarget.textContent = paused ? '▶' : 'Ⅱ'; event.currentTarget.setAttribute('aria-label', paused ? t('autoplay_resume') : t('autoplay_pause')); startTimer(); });
    track.addEventListener('scroll', update, { passive: true });
    const resizeObserver = new ResizeObserver(update); resizeObserver.observe(track); update(); startTimer();
    slider._stop = () => { clearInterval(timer); resizeObserver.disconnect(); };
  }
  let predictiveController, predictiveTimeout;
  document.addEventListener('input', event => {
    const input = event.target.closest('[data-predictive-input]'); if (!input) return;
    const results = input.closest('form').querySelector('[data-predictive-results]'), query = input.value.trim();
    clearTimeout(predictiveTimeout); predictiveController?.abort();
    if (query.length < 2) { results.replaceChildren(); input.setAttribute('aria-expanded', 'false'); return; }
    predictiveTimeout = setTimeout(async () => {
      predictiveController = new AbortController();
      try {
        const response = await fetch(`${root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`, { signal: predictiveController.signal });
        if (!response.ok) throw new Error(t('search_unavailable'));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('.predictive-results'); results.replaceChildren(); if (content) results.append(content);
        input.setAttribute('aria-expanded', String(!!content));
      } catch (error) { if (error.name !== 'AbortError') { results.textContent = t('search_enter'); input.setAttribute('aria-expanded', 'false'); } }
    }, 220);
  });
  document.addEventListener('click', async event => {
    const share = event.target.closest('[data-share-url]');
    if (share) { try { if (navigator.share) await navigator.share({ url: share.dataset.shareUrl }); else { await navigator.clipboard.writeText(share.dataset.shareUrl); status(t('link_copied')); } } catch { status(t('share_failed')); } }
    const copy = event.target.closest('[data-copy-code]');
    if (copy) { try { await navigator.clipboard.writeText(copy.closest('dialog').querySelector('[data-discount-code]').textContent); copy.closest('dialog').querySelector('[data-copy-status]').dataset.copied = 'true'; } catch { status(t('copy_code')); } }
  });
  function initAddress(select) {
    if (select.dataset.initialized) return; select.dataset.initialized = 'true';
    const province = document.getElementById(select.dataset.provinceId); if (!province) return;
    if (select.dataset.default) select.value = select.dataset.default;
    function update() {
      const provinces = JSON.parse(select.selectedOptions[0]?.dataset.provinces || '[]'); province.replaceChildren();
      provinces.forEach(([value, label]) => province.add(new Option(label, value)));
      province.closest('[data-province-container]').hidden = provinces.length === 0;
      if (province.dataset.default) province.value = province.dataset.default;
    }
    select.addEventListener('change', update); update();
  }
  document.addEventListener('submit', event => { if (event.target.matches('[data-address-delete]') && !confirm(t('confirm_delete_address'))) event.preventDefault(); });
  function init(scope = document) { scope.querySelectorAll('[data-product]').forEach(initProduct); scope.querySelectorAll('[data-slider]').forEach(initSlider); scope.querySelectorAll('[data-address-country]').forEach(initAddress); }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-slider]').forEach(el => el._stop?.()); event.target.querySelectorAll('[data-product]').forEach(el => el._observer?.disconnect()); });
  document.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-slide]'); const track = slide?.closest('[data-slider-track]'); if (track) track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: motion() }); });
  const scrollTop = document.querySelector('[data-scroll-top]');
  window.addEventListener('scroll', () => { document.querySelector('[data-header]')?.classList.toggle('header-small', window.scrollY > 100); if (scrollTop) scrollTop.hidden = window.scrollY < Number(scrollTop.dataset.after || 400); }, { passive: true });
  document.addEventListener('shopify:section:select', event => {
    const selectedPromo = event.target.querySelector('[data-promo]');
    if (selectedPromo) openDialog(selectedPromo.id);
  });
  document.addEventListener('shopify:section:deselect', event => event.target.querySelector('[data-promo]')?.close());
  const promo = document.querySelector('[data-promo]');
  if (promo) {
    let countdown;
    promo.addEventListener('toggle', () => {
      clearInterval(countdown);
      const clock = promo.querySelector('[data-promo-timer]');
      if (!promo.open || !clock) return;
      const end = Date.now() + Number(clock.dataset.seconds || 180) * 1000;
      const tick = () => {
        const left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        clock.textContent = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
        if (!left) clearInterval(countdown);
      };
      tick(); countdown = setInterval(tick, 1000);
    });
    promo.addEventListener('close', () => clearInterval(countdown));
  }
  if (promo && !window.Shopify?.designMode && promo.dataset.mode === 'enabled') {
    const storageKey = 'ivonne-promo-dismissed'; let lastDismissal = 0;
    try { lastDismissal = Number(localStorage.getItem(storageKey) || 0); } catch {}
    if (promo.querySelector('[data-promo-success]') || Date.now() - lastDismissal > Number(promo.dataset.days || 30) * 86400000) {
      setTimeout(() => { if (!document.querySelector('dialog[open]')) openDialog(promo.id); }, promo.querySelector('[data-promo-success]') ? 0 : Math.max(0, Number(promo.dataset.delay || 60000)));
    }
    promo.addEventListener('close', () => { try { localStorage.setItem(storageKey, String(Date.now())); } catch {} });
  }
})();
